import { observer } from 'mobx-react';
import { henshu, useHenshu } from '@strategies/henshu';

import Section from '../Section';
import rightArrowIcon from '../../assets/arrow-icon-orange.svg';
import camera from '../../assets/video.svg';
import file from '../../assets/file-icon.svg'; 
import React from 'react';

const ICONS = { camera, file };

export default observer(function Resources() {
    const { bindTo } = useHenshu();

    return <Section index={3} name={'Resources'}>
        <ul>
            <henshu.each {...bindTo('Resources')}>
                {(bindToEach) => (
                    <li style={{ background: '#D9EAE4' }}>
                        <a className="unstyled" href={bindToEach('image').get()} target={'_blank'}>
                            <div className="resource-content">
                                <div className="icon-wrapper">
                                    <img src={ICONS[bindToEach('icon').get()]} alt="Resource icon" aria-hidden="true" />
                                    <img src={rightArrowIcon} alt="Continue icon" aria-hidden="true" />
                                </div>
                                <henshu.h4  {...bindToEach('title')} />
                                <henshu.p  {...bindToEach('subtitle')} />
                            </div>
                        </a>
                    </li>
                )
                }
            </henshu.each>
        </ul>
    </Section>
});
